import React, { useContext } from 'react'

type TranscriptionLogContextType = {
  onPause?: () => void
  onPlay?: (millis?: number) => void
  isPlaying: boolean
  elapsedTimeMillis: number
}

const TranscriptionLogContext =
  React.createContext<TranscriptionLogContextType>({
    isPlaying: false,
    elapsedTimeMillis: 0,
  })
const useTranscriptionLogContext = () => {
  return useContext(TranscriptionLogContext)
}

export default useTranscriptionLogContext
export const TranscriptionLogContextProvider = TranscriptionLogContext.Provider
